import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=3c5b6d18"
import script from "./GroupCreate.vue?vue&type=script&lang=js"
export * from "./GroupCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports